'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAsaCompliant = function isAsaCompliant(text) {
  var asaTags = ['#ad\\b', '\\bad\\b', // standalone "ad" in text
  '#spon', '#partner', '#pr\\b', // #pr but not #price #pretty
  '\\bpr\\b', // standalone PR in text
  '(?:^|\\n)\\s*AD\\s*[\\|\\-\\:–—]', // "AD | ..." at start of line
  '(?:^|\\n)\\s*PR\\s*[\\|\\-\\:–—]', // "PR | ..." at start of line
  '#gifted\\b', // #gifted but not #giftedlife
  '\\bgifted\\b', // standalone "gifted" in text
  '\\bkindly\\s+gifted\\b', // "kindly gifted"
  '\\bgifted\\s+by\\b', // "gifted by [brand]"
  '#giftedproduct', '#gifteditem', '#giftedcollab'];
  var asaRegex = new RegExp(_lodash2.default.join(asaTags, '|'), 'igm');
  return asaRegex.test(text);
};

exports.default = isAsaCompliant;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/asa-compliance.js
 ** module id = 978
 ** module chunks = 0
 **/